import React, { useState, useEffect, useContext } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
// import products from "../../products.json";
import "../../../index.css";
import { useNavigate } from "react-router-dom";
import {
  BASE_URL,
  Severities,
  alarmStatuses,
  formatAlarmValue,
} from "./../../../constant";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppContext from "../../../AppContext";
import { formatDate } from "@telerik/kendo-intl";
import KendoLoadingPanel from "../../KendoLoadingPanel";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import ColumnMenuFilter from "../../assetDetails/ColumnMenuFilter";
import { process } from "@progress/kendo-data-query";
import { useTranslation } from "react-i18next";

const Severity = [
  {
    value: "~ALL",
    label: "",
    id: "allAlarms",
  },
  ...Severities.map((x) => ({ ...x, id: x.value + "Alarms" })),
];
const statusCountDisplays = [
  {
    value: "~ALL",
  },
  ...alarmStatuses,
];

const CountDisplay = ({
  severity,
  icon,
  tooltip,
  setFilterState,
  filterState,
  name,
  alarmCounts,
  loadData,
  displayLength,
  setPageState,
  loading,
  t,
}) => {
  const value = alarmCounts[severity.id];
  const count = value[name === "~ALL" ? "total" : name];
  return (
    <button
      onClick={() => {
        let state = { skip: 0, take: 10 };
        let filter = { severity: severity.value, status: name };
        setFilterState((pre) => ({ ...pre, ...filter }));
        loadData(state, filter);
        const totalCount = alarmCounts[severity.id];
        let status = name === "~ALL" ? "total" : name;
        setPageState((pre) => ({
          ...pre,
          total: totalCount ? totalCount[status] : 0,
        }));
      }}
      className={`font-bold lg:text-xl md:text-md text-xs ${
        name !== "~ALL" ? "border-l border-slate-100 justify-center" : ""
      } text-ellipsis flex h-fit w-1/${displayLength} min-w-fit px-2 transition-all delay-75 items-center`}
    >
      <div
        className={`tooltip flex ${
          filterState.severity === severity.value && filterState.status === name
            ? `border-b-4 ${
                filterState.status === "~ALL"
                  ? "justify-start w-fit"
                  : "justify-center w-full"
              }  border-white`
            : ""
        } ${loading ? "pb-2 w-full" : ""} items-center gap-1`}
      >
        {icon && <img src={icon} className="lg:h-4 md:h-3 sm:h-2" alt="icon" />}
        {tooltip !== undefined && (
          <span className="tooltiptext w-fit truncate text-xs font-medium">
            {tooltip}
          </span>
        )}
        {!loading ? (
          count
        ) : (
          <div
            role="status"
            class="max-w-full w-full flex gap-1 items-center animate-pulse"
          >
            <div class="h-3 bg-gray-400 rounded-full w-1/2"></div>
            <div class="h-3 bg-gray-400 rounded-full w-1/2"></div>
            <span class="sr-only">Loading...</span>
          </div>
        )}
      </div>
    </button>
  );
};

const AlarmList = () => {
  const { t } = useTranslation();
  const currentDate = new Date();
  const dayStartTime = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);
  const defaultFilter = {
    asset: { id: "~ALL", name: t("masters.labels.all") },
    startDate: dayStartTime,
    endDate: currentDate,
    severity: Severity[0].value,
    status: "~ALL",
  };
  const { assets, darkMode } = useContext(AppContext);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterState, setFilterState] = useState({
    assetName: [],
    sensorName: "",
    lastStatus: [],
    sensorValue: { operator: "=", value: null },
    status: [],
    acknowledgeTime: {
      start: null,
      end: null,
    },
    clearedTime: {
      start: null,
      end: null,
    },
    timeStamp: {
      start: null,
      end: null,
    },
    acknowledgeUser: "",
    clearedUser: "",
  });
  const [loading, setLoading] = useState({
    dataLoader: false,
    countLoader: false,
  });
  const [assetData, setAssetData] = useState([
    { id: "~ALL", name: t("masters.labels.all") },
  ]);
  const [filter, setFilter] = useState(defaultFilter);
  const [loaded, setLoaded] = useState(false);
  const [pageState, setPageState] = useState({ take: 10, skip: 0, total: 0 });
  const [alarmCounts, setAlarmCounts] = useState({
    allAlarms: {
      open: 0,
      acknowledged: 0,
      closed: 0,
      total: 0,
    },
    infoAlarms: {
      open: 0,
      acknowledged: 0,
      closed: 0,
      total: 0,
    },
    warningAlarms: {
      open: 0,
      acknowledged: 0,
      closed: 0,
      total: 0,
    },
    criticalAlarms: {
      open: 0,
      acknowledged: 0,
      closed: 0,
      total: 0,
    },
  });
  const navigate = useNavigate();

  const onSearch = (e) => {
    setFilter((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const loadCounts = async (state) => {
    setLoading({ dataLoader: true, countLoader: true });
    let start = new Date(filter.startDate).toISOString().slice(0, 23) + "Z";
    let end = new Date(filter.endDate).toISOString().slice(0, 23) + "Z";
    const assetIds = [];
    if (filter.asset.id === "~ALL") {
      assets.forEach((element) => {
        assetIds.push(element.id);
      });
    } else assetIds.push(filter.asset.id);

    try {
      const res = await axios.get(
        `${BASE_URL}/AssetAlarm/GetAlarmsCount?assetId=${assetIds.join(
          ","
        )}&startDate=${start}&endDate=${end}`
      );
      setAlarmCounts(res.data);
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
    }
    setLoading((pre) => ({ ...pre, countLoader: false }));
  };

  const loadData = async (state, filterState) => {
    setData([]);
    setFilteredData([]);
    setLoading((pre) => ({ ...pre, dataLoader: true }));
    let start = new Date(filter.startDate).toISOString().slice(0, 23) + "Z";
    let end = new Date(filter.endDate).toISOString().slice(0, 23) + "Z";
    const assetIds = [];
    if (filter.asset.id === "~ALL") {
      assets.forEach((element) => {
        assetIds.push(element.id);
      });
    } else assetIds.push(filter.asset.id);

    try {
      const res = await axios.get(
        `${BASE_URL}/AssetAlarm/GetAllAlarms?assetId=${assetIds.join(
          ","
        )}&status=${filterState.status}&severity=${
          filterState.severity
        }&startDate=${start}&endDate=${end}`
      );
      const finalData = res.data.map((x) => {
        const asset =
          assets.length > 0 ? assets.find((y) => y.id === x.assetId) : null;
        const parameter =
          asset &&
          asset?.parameters.find((y) => x.parameterId === y.parameterId);
        const isCleared = x.clearedUser !== null;
        const isAcknowledged = x.acknowledgeUser != null;
        return {
          ...x,
          sensorName: parameter?.name,
          assetName: asset?.name,
          lastStatus: isCleared
            ? t("masters.labels.closed")
            : isAcknowledged
            ? t("masters.labels.acknowledged")
            : t("masters.labels.open"),
        };
      });
      setPageState({ ...state, total: res.data.length });
      setData(finalData);
      setFilteredData(finalData);
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
    }
    setLoading((pre) => ({ ...pre, dataLoader: false }));
  };

  const getSensorName = (parameterId, asset) => {
    const data = asset?.parameters?.find((p) => p.parameterId === parameterId);
    return data;
  };

  const getAsset = (assetId) => {
    const data = assets.find((p) => p.id === assetId);
    return data;
  };

  const RenderCell = (props) => {
    const { field, dataItem } = props;
    const {
      assetId,
      parameterId,
      timeStamp,
      acknowledgeTime,
      acknowledgeUser,
      sensorValue,
      clearedUser,
      clearedTime,
      status,
      alarmType,
    } = dataItem;

    const asset = getAsset(assetId);
    const parameter = getSensorName(parameterId, asset);

    const renderAssetId = () => asset?.name;
    const renderSensorId = () => parameter?.name;
    const renderTimeStamp = () =>
      formatDate(new Date(timeStamp), "dd MMM yyyy hh:mm a");
    const renderAcknowledgeTime = () =>
      acknowledgeUser ? (
        formatDate(new Date(acknowledgeTime), "dd MMM yyyy hh:mm a")
      ) : (
        <div className="text-gray-600">
          {t("masters.labels.notAcknowledged")}
        </div>
      );
    const renderClearedTime = () =>
      clearedUser ? (
        formatDate(new Date(clearedTime), "dd MMM yyyy hh:mm a")
      ) : (
        <div className="text-gray-600">{t("masters.labels.notClosed")}</div>
      );
    const renderClearedUser = () =>
      !clearedUser ? (
        <div className="text-gray-600"> {t("masters.labels.notClosed")}</div>
      ) : (
        clearedUser
      );
    const renderAcknowledgeUser = () =>
      !acknowledgeUser ? (
        <div className="text-gray-600">
          {t("masters.labels.notAcknowledged")}
        </div>
      ) : (
        acknowledgeUser
      );
    const renderSensorValue = () => (
      <div>
        {formatAlarmValue(alarmType, sensorValue, "flex-col")}
        &nbsp;
        {getSensorName(parameterId, assetId)?.unit}
      </div>
    );

    const renderAlarmSeverity = () => (
      <div
        className={`
          ${
            status === "info"
              ? " border-blue-700 text-blue-700"
              : status === "warning"
              ? "border-amber-200 text-amber-200"
              : status === "critical"
              ? " border-red-600 text-red-600"
              : ""
          } rounded-2xl flex justify-center items-center h-6 w-20 border`}
      >
        {t(`home.alarmList.status.${status}`)}
        {/* {status === "info"
          ? "Info"
          : status === "warning"
          ? "Warning"
          : status === "critical" && "Critical"} */}
      </div>
    );

    const renderAction = () => {
      const isCleared = clearedUser !== null;
      const isAcknowledged = acknowledgeUser != null;
      const iconName = isCleared
        ? "clear-icon.svg"
        : isAcknowledged
        ? "Acknowledge-icon.svg"
        : "Eye-icon.svg";
      const label = isCleared
        ? t("masters.labels.closed")
        : isAcknowledged
        ? t("masters.labels.acknowledged")
        : t("masters.labels.open");

      return (
        <div
          className={`flex gap-2 h-7 w-fit items-center disabled:opacity-30`}
        >
          <img src={iconName} className="h-6" alt={label.toLowerCase()} />
          <label>{label}</label>
        </div>
      );
    };

    const fieldRenderers = {
      assetName: renderAssetId,
      sensorName: renderSensorId,
      timeStamp: renderTimeStamp,
      acknowledgeTime: renderAcknowledgeTime,
      clearedTime: renderClearedTime,
      clearedUser: renderClearedUser,
      acknowledgeUser: renderAcknowledgeUser,
      sensorValue: renderSensorValue,
      lastStatus: renderAction,
      status: renderAlarmSeverity,
    };

    const content = fieldRenderers[field]?.();

    return <td className="px-2 py-3">{content}</td>;
  };

  const Assets =
    assets &&
    assets.map((x) => {
      return {
        label: x.name,
        value: x.id,
      };
    });

  const columns = [
    {
      field: "assetName",
      title: t("masters.fields.asset"),
      show: true,
      width: "auto",
      columnMenuType: "dropdown",
      columnMenuData: Assets,
      filterable: filter.asset?.id === "~ALL",
      cell: RenderCell,
    },
    {
      field: "sensorName",
      title: t("masters.fields.sensor"),
      show: true,
      width: "auto",
      filterable: true,
      columnMenuType: "textbox",
      cell: RenderCell,
    },
    {
      field: "sensorValue",
      title: t("masters.fields.value"),
      show: true,
      width: 90,
      columnMenuType: "number",
      filterable: true,
      cell: RenderCell,
    },
    {
      field: "status",
      title: t("masters.fields.severity"),
      show: true,
      width: 100,
      filterable: filter.status === "~ALL",
      columnMenuType: "dropdown",
      columnMenuData: Severities,
      cell: RenderCell,
    },
    {
      field: "timeStamp",
      title: t("masters.fields.alrmTime"),
      show: true,
      width: "auto",
      filterable: true,
      columnMenuType: "date",
      cell: RenderCell,
    },
    {
      field: "acknowledgeTime",
      title: t("masters.fields.acknowledgeTime"),
      show: true,
      width: "auto",
      filterable: true,
      columnMenuType: "date",
      cell: RenderCell,
    },
    {
      field: "acknowledgeUser",
      title: t("masters.fields.acknowledgeBy"),
      show: true,
      width: "auto",
      filterable: true,
      columnMenuType: "textbox",
      cell: RenderCell,
    },
    {
      field: "clearedTime",
      title: t("masters.fields.closedTime"),
      show: true,
      width: "auto",
      filterable: true,
      columnMenuType: "date",
      cell: RenderCell,
    },
    {
      field: "clearedUser",
      title: t("masters.fields.closedBy"),
      show: true,
      width: "auto",
      filterable: true,
      columnMenuType: "textbox",
      cell: RenderCell,
    },
    {
      field: "lastStatus",
      title: t("masters.fields.lastStatus"),
      show: true,
      width: 145,
      filterable: filter.severity === "~ALL",
      columnMenuType: "dropdown",
      columnMenuData: alarmStatuses,
      cell: RenderCell,
    },
  ];

  const onCloseClick = (e) => {
    navigate(`/`);
  };

  const onPageChange = (e) => {
    const state = { ...pageState, skip: e.page.skip, take: e.page.take };
    setPageState(state);
  };

  const filterDataByFilter = (latestData, filterState) => {
    const selectedStatuses = filterState?.lastStatus?.map((x) => x.label);
    const finalData = latestData
      .filter((x) => {
        if (selectedStatuses.length > 0) {
          return selectedStatuses.includes(x.lastStatus);
        }
        return true; // No filter applied for status if it's in the default state
      })
      .filter((x) => {
        if (filterState.sensorName !== "") {
          const foundedAsset = getAsset(x.assetId);
          const foundedParameter = getSensorName(x.parameterId, foundedAsset);
          return foundedParameter.name
            .toLowerCase()
            .includes(filterState.sensorName.toLowerCase());
        }
        return true; // No filter applied for sensorName if it's in the default state
      })
      .filter((x) => {
        if (x.acknowledgeUser !== null)
          if (filterState.acknowledgeUser !== "") {
            return x.acknowledgeUser
              .toLowerCase()
              .includes(filterState.acknowledgeUser.toLowerCase());
          }
        return false; // No filter applied for sensorName if it's in the default state
      })
      .filter((x) => {
        if (x.clearedUser !== null)
          if (filterState.clearedUser !== "") {
            return x.clearedUser
              ?.toLowerCase()
              .includes(filterState.clearedUser.toLowerCase());
          }
        return false; // No filter applied for sensorName if it's in the default state
      })
      .filter((x) => {
        if (filterState.assetName.length > 0) {
          return filterState.assetName.some((a) => a.value === x.assetId);
        }
        return true; // No filter applied for severity if it's in the default state
      })
      .filter((x) => {
        if (filterState.status.length > 0) {
          return filterState.status.some((s) => s.value === x.status);
        }
        return true; // No filter applied for severity if it's in the default state
      })
      .filter((x) => {
        if (
          filterState.sensorValue.value !== null &&
          filterState.sensorValue.value !== ""
        ) {
          const parsedValue = parseFloat(x.sensorValue?.toFixed(2));
          if (filterState.sensorValue.operator === "=") {
            return parsedValue === parseFloat(filterState.sensorValue.value);
          } else if (filterState.sensorValue.operator === ">") {
            return parsedValue > filterState.sensorValue.value;
          } else if (filterState.sensorValue.operator === "<") {
            return parsedValue < filterState.sensorValue.value;
          }
        }
        return true; // No filter applied for sensorValue if it's in the default state
      })
      .filter((x) => {
        if (
          filterState.acknowledgeTime?.start !== null ||
          filterState.acknowledgeTime?.end !== null
        ) {
          if (x.acknowledgeUser !== null) {
            return (
              (filterState.acknowledgeTime.start === null ||
                new Date(x.acknowledgeTime) >=
                  new Date(filterState.acknowledgeTime.start)) &&
              (filterState.acknowledgeTime.end === null ||
                new Date(x.acknowledgeTime) <=
                  new Date(filterState.acknowledgeTime.end))
            );
          } else return false;
        }
        return true;
        // No filter applied for timeStamp if it's in the default state
      })
      .filter((x) => {
        if (
          filterState.clearedTime?.start !== null ||
          filterState.clearedTime?.end !== null
        ) {
          if (x.clearedUser !== null) {
            return (
              (filterState.clearedTime.start === null ||
                new Date(x.clearedTime) >=
                  new Date(filterState.clearedTime.start)) &&
              (filterState.clearedTime.end === null ||
                new Date(x.clearedTime) <=
                  new Date(filterState.clearedTime.end))
            );
          } else return false;
        }
        return true;
        // No filter applied for timeStamp if it's in the default state
      })
      .filter((x) => {
        if (
          filterState.timeStamp?.start !== null ||
          filterState.timeStamp?.end !== null
        ) {
          return (
            (filterState.timeStamp.start === null ||
              new Date(x.timeStamp) >= new Date(filterState.timeStamp.start)) &&
            (filterState.timeStamp.end === null ||
              new Date(x.timeStamp) <= new Date(filterState.timeStamp.end))
          );
        }
        return true; // No filter applied for timeStamp if it's in the default state
      });

    setFilteredData(
      finalData.sort((a, b) => new Date(b.timeStamp) - new Date(a.timeStamp))
    );
    setPageState({ skip: 0, take: 10, total: finalData.length });
  };

  useEffect(() => {
    filterDataByFilter(data, filterState);
  }, [filterState]);

  const onFilterSubmit = async () => {
    await loadCounts(pageState);
    await loadData(pageState, filter);
  };

  useEffect(() => {
    if (assets)
      setAssetData([
        { id: "~ALL", name: "ALL" },
        ...assets.map((x) => ({
          id: x.id,
          name: x.name,
        })),
      ]);
    if (assets && assets.length > 0 && !loaded) loadDetails();
  }, [assets]);

  // useEffect(() => {}, []);

  const loadDetails = async () => {
    setLoaded(true);
    await loadCounts(pageState);
    await loadData(pageState, filter);
  };

  return (
    <div className="flex flex-col dark:text-white text-labels px-14 pt-7 pb-2 dark:bg-neutral-900 bg-lightModeBg h-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-5">
          <div className="flex text-xs font-medium gap-3 items-center">
            <button type="button" onClick={onCloseClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2.0"
                stroke="currentColor"
                className="w-7 h-7"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
                />
              </svg>
            </button>
            <label>{t("masters.headerTexts.home")}</label>
          </div>
          <hr className="rotate-90 w-10 h-1 border-zinc-800"></hr>
          <label className="text-zinc-600 text-sm font-medium">
            {t("masters.headerTexts.alrmList")}
          </label>
          <div className={`flex gap-2 items-center ${darkMode ? "darkCombo" : "lightCombo"}`}>
            <DateTimePicker
              className="md:h-7 h-5 w-32 md:text-xs text-xxs placeholder:text-white"
              placeholder="Start Range"
              width={200}
              format="dd-MM-yyyy hh:mm a"
              value={filter.startDate}
              onChange={(e) =>
                setFilter((pre) => ({
                  ...pre,
                  startDate: e.target.value,
                }))
              }
            />
            <DateTimePicker
              className="md:h-7 h-5 md:text-xs text-xxs placeholder:text-white"
              placeholder="End Range"
              format="dd-MM-yyyy hh:mm a"
              width={200}
              value={filter.endDate}
              onChange={(e) =>
                setFilter((pre) => ({
                  ...pre,
                  endDate: e.target.value,
                }))
              }
            />
            <div className="relative bg-gray-900 w-56 h-7 rounded-lg border-zinc-800">
              <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                <svg
                  aria-hidden="true"
                  className="w-5 h-5 text-neutral-700"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  ></path>
                </svg>
              </div>
              <div id="compo">
                <ComboBox
                  id="default-search"
                  textField="name"
                  data={assetData}
                  dataItemKey="id"
                  name="asset"
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    borderColor: "transparent",
                  }}
                  clearButton={false}
                  className=" block border-gray-400 text-white rounded-lg mb-4 h-7"
                  placeholder="Search Asset"
                  onChange={onSearch}
                  value={filter.asset}
                  required
                />
              </div>
            </div>
            <button
              type="button"
              className="bg-indigo-600 md:px-2 text-xs px-1 font-medium md:h-7 h-5 my-auto rounded"
              onClick={() => onFilterSubmit()}
            >
              {t("button.apply")}
            </button>
            <button
              type="button"
              className="bg-red-500 md:px-2 px-1 text-xs font-medium md:h-7 h-5 my-auto rounded"
              // onClick={() => onPlayBackClear()}
            >
              {t("button.clear")}
            </button>
          </div>
        </div>
      </div>
      <div className="flex py-7 justify-between gap-2">
        {Severity.map((severity) => (
          <div
            key={severity.value}
            className={`flex flex-col px-3 py-5 md:w-1/4 min-w-fit h-fit ${
              severity.value === filter.severity ? "border-2 border-white" : ""
            } rounded-lg dark:bg-[#22252F] bg-gray2`}
          >
            <div className="flex w-full min-w-fit">
              {statusCountDisplays.map((x) => (
                <CountDisplay
                  severity={severity}
                  icon={x.icon}
                  tooltip={t(`masters.labels.${x.tooltip}`)}
                  filterState={filter}
                  setFilterState={setFilter}
                  name={x.value}
                  alarmCounts={alarmCounts}
                  loadData={loadData}
                  displayLength={statusCountDisplays.length}
                  loading={loading.countLoader}
                  setPageState={setPageState}
                  t={t}
                />
              ))}
            </div>
            <div className="font-medium text-xxs pt-2">
              {t("masters.headerTexts.ttl")}{" "}
              {severity.value !== "~ALL" &&
                t(`home.alarmList.status.${severity.value}`)}{" "}
              {t("masters.headerTexts.alarms")}
            </div>
          </div>
        ))}
      </div>
      <div
        className={`h-[57vh] mt-2 relative w-full ${
          darkMode ? "darkGrid" : "lightGrid"
        }`}
      >
        {loading.dataLoader && <KendoLoadingPanel />}
        <Grid
          style={{
            width: "100%",
            backgroundColor: "#181921",
            borderRadius: "17px",
            textAlign: "justify",
            fontSize: "10px",
          }}
          className="h-full text-xs"
          data={process(filteredData, { ...pageState })}
          scrollable={{ virtual: true, scrollMode: "scrollable" }}
          pageable={{
            pageSizes: true,
          }}
          onPageChange={onPageChange}
          {...pageState}
        >
          {columns.map(
            (column, idx) =>
              column.show && (
                <GridColumn
                  key={idx}
                  field={column.field}
                  title={column.title}
                  filterable={column.filterable}
                  cell={column.cell}
                  headerClassName="text-[12px]"
                  width={column.width}
                  columnMenu={
                    column.filterable
                      ? (props) =>
                          ColumnMenuFilter({
                            ...props,
                            type: column.columnMenuType,
                            data: column.columnMenuData,
                            setFilterData: setFilterState,
                            filterData: filterState,
                            defaultFilter: filter,
                          })
                      : null
                  }
                  className="product-name"
                />
              )
          )}
        </Grid>
        <br />
      </div>
    </div>
  );
};

export default AlarmList;
